import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import SEO from "@/components/seo/SEO";

export default function VerifyEmail() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | success | error

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState("error");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => setState("success"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <SEO title="Vérification de l'email | Kalypso Music" description="Vérification de votre adresse email Kalypso Music." path="/verify-email" noindex />
      <div className="w-full max-w-md text-center">
        <Link to="/" className="mb-8 flex items-center justify-center gap-2">
          <img src="/logo.png" alt="Kalypso Music" className="h-10 w-10 rounded-xl object-cover" />
          <span className="font-heading text-xl font-semibold">Kalypso Music</span>
        </Link>
        <div className="rounded-2xl border border-border bg-card p-10">
          {state === "loading" && <Loader2 className="mx-auto h-10 w-10 animate-spin text-primary" />}
          {state === "success" && (
            <>
              <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-500" />
              <p className="mt-4 text-sm text-muted-foreground">{t("auth.verifyEmailSuccess")}</p>
            </>
          )}
          {state === "error" && (
            <>
              <XCircle className="mx-auto h-10 w-10 text-destructive" />
              <p className="mt-4 text-sm text-muted-foreground">{t("auth.verifyEmailError")}</p>
            </>
          )}
          <Link to="/dashboard" className="mt-6 inline-block text-sm font-medium text-primary hover:underline">
            {t("nav.dashboard")}
          </Link>
        </div>
      </div>
    </div>
  );
}
